import { useState, useEffect, useCallback } from 'react';
import styles from '../styles/CustomersSection.module.css';
import CustomSelect from '../customComponents/CustomSelect';
import AddCustomerModal from '../customComponents/AddCustomerModal';
import { API_URL } from '../config/api';

const typeMap = {
  individual: 'ИП',
  llp: 'ТОО',
  jsc: 'АО',
  fl: 'ФЛ',
};

const CustomersSection = () => {
  const [type, setType] = useState('');
  const [client, setClient] = useState('');
  const [contractors, setContractors] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);

  const fetchContractors = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_URL}/api/contractors?type=client`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, 
        },
      });

      const data = await response.json();
      console.log("📦 Ответ API:", data);

      if (Array.isArray(data?.data)) {
        setContractors(data.data);
        console.log("✅ Загружено:", data.data.length, "контрагентов");
      } else {
        console.warn("⚠️ Ответ без data:", data);
        setContractors([]);
      }
    } catch (err) {
      console.error("💥 Ошибка при загрузке:", err);
      setContractors([]);
    }
  }, []);

  useEffect(() => {
    fetchContractors();
  }, [fetchContractors]);

  return (
    <div className={styles.container}>
      <button
        className={styles.addCustomers}
        onClick={() => setShowAddModal(true)}
      >
        +
      </button>

      {showAddModal && (
        <AddCustomerModal
          onClose={() => setShowAddModal(false)}
          onCustomerAdded={() => {
            fetchContractors();
            setShowAddModal(false);
          }}
        />
      )}

      <div className={styles.debt}>
        <h3 className={styles.deptHead}>Общая задолженность</h3>
        <p className={styles.debtSum}>
          {contractors.reduce((sum, c) => sum + (parseFloat(c.debt_sum) || 0), 0).toFixed(2)}
        </p>
      </div>

      <div className={styles.filter}>
        <CustomSelect
          className={styles.filters__select}
          options={['Текущие клиенты']}
          value={client}
          onChange={setClient}
          placeholder="Тип клиента"
        />
        <input type="date" className={styles.input} />
        <input type="text" className={styles.input} placeholder="Поиск по имени" />
        <input type="text" className={styles.input} placeholder="ИИН/БИН" />
        <input type="text" className={styles.input} placeholder="+7 (XXX) XXX-XX-XX" />
        <CustomSelect
          className={styles.filters__select}
          options={['ИП', 'ТОО', 'АО', 'ФЛ']}
          value={type}
          onChange={setType}
          placeholder="Тип компаний"
        />
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Имя</th>
              <th>ИИН/БИН</th>
              <th>Телефон</th>
              <th>Сумма задолженности</th>
              <th>Тип</th>
              <th>Дата</th>
            </tr>
          </thead>
          <tbody>
            {contractors.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>Нет данных</td>
              </tr>
            ) : (
              contractors.map((item) => (
                <tr key={item.id}>
                  <td>{item.name || '—'}</td>
                  <td>{item.sn || '—'}</td>
                  <td>{item.phone || '—'}</td>
                  <td>{item.debt_sum ? item.debt_sum : '0.00'}</td>
                  <td>{typeMap[item.org_type] || '—'}</td>
                  <td>{item.inserted_at?.split('T')[0] || '—'}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomersSection;
